import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Mi volas esti ŝtala plugilo <br/>
        Por traplugi tutan la Teron. <br/>
        Jen gitaro kun kolo <br/>
        Simila al la sol-kleo, <br/>
        Jen papilio bela, gracia kaj delikata, <br/>
        Jen trifolio svelta sur freŝa verda herbejo.
      </p>

      <p class="poem-block mb-3">
        Ĉion ĉi mi traplugos, enmergos en teron nigran <br/>
        Kaj poste oni prisemos miajn faükantajn spurojn, <br/>
        Aspektajn kiel la vundoj sur la vizaĝ’ de la Tero, <br/>
        Larĝaj kaj nigraj vundoj kun disŝutantaj randoj. <br/>
        El ili elkreskos nova, mola kaj verda herbo, <br/>
        Sed ne plu restos la olda. Nenion oldan mi lasos! <br/>
        Nur nova gento donos feliĉon al la homaro!
      </p>

      <p class="poem-block mb-3">
        Mi volas esti ŝtala plugilo <br/>
        Por traplugi tutan la Teron. <br/>
        Kaj poste iu prisemos <br/>
        Lasitajn de mi nigrajn spurojn.
      </p>
    </div>
    `
  )
}
const itemName = {
  esp: 'Revoluciulo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;